/**
 * AppCountryFlags bond setup
 *
 * Wires @molecule/app-country-flags-country-flag-icons to
 * @molecule/app-country-flags (the model picker's processing-region flags).
 */

import { setCountryFlags } from '@molecule/app-country-flags'
import { countryFlags } from '@molecule/app-country-flags-country-flag-icons'

export function setupAppCountryFlags(): void {
  setCountryFlags(countryFlags)
}
